import { motion } from "framer-motion";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect } from "react";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  size?: string;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  size = "1200px",
  children,
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <motion.div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-90"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={onClose}
    >
      <motion.div
        className={`relative mx-5 w-full p-5 bg-[#fff] rounded-lg shadow-lg`}
        initial={{ scale: 0.8 }}
        animate={{ scale: 1 }}
        exit={{ scale: 0.8 }}
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: size }}
      >
        <button
          className="absolute z-10 flex items-center justify-center w-6 h-6 bg-gray-300 rounded-full hover:text-white top-2 right-2 hover:bg-primary"
          onClick={onClose}
        >
          <CloseIcon sx={{ fontSize: "16px" }} />
        </button>
        {children}
      </motion.div>
    </motion.div>
  );
};

export default Modal;
